import { v4 as uuidv4 } from 'uuid';

export const createAtomMapping = (nodes, rootCompoundId = 0) => {
  const rootReactionId = nodes[rootCompoundId].successors[0];

  if (!rootReactionId) {
    return {};
  }

  const rootReaction = nodes[rootReactionId];

  const mapping = {
    [rootCompoundId]: rootReaction.productToMap.map(() => uuidv4()),
  };

  const queue = [rootReaction];

  while (queue.length > 0) {
    const reaction = queue.shift();
    const { predecessor, successors, productToMap, substratesToMap } = reaction;
    const productMapping = mapping[predecessor];

    successors.forEach((substrateId, i) => {
      const nextReactionId = nodes[substrateId].successors[0];
      const substrateToMap = substratesToMap[i];

      mapping[substrateId] = substrateToMap.map(globalId => {
        return productMapping.find((uid, i) => productToMap[i] === globalId) || uuidv4();
      });

      if (nextReactionId) {
        queue.push(nodes[nextReactionId]);
      }
    });
  }

  return mapping;
};
